import {
  clinicReferralNavWrapper,
  apptBeforeVisitsWrapper,
  fuHtnBotStartRequested,
  fuDmBotStartRequested,
  fuMhBotStartRequested,
  markNotificationAsSeen,
  navToPrescription,
  navToMedicalNote,
  navToReferralResult,
  navToLabReferral,
  navToQuestReferral,
  fuPrimaryHmoBotStartRequested,
  navToSingleClaim
} from './notificationLinksNavHelper'

export const navigationMapper = {
  clinicReferral: clinicReferralNavWrapper,
  nav_to_appointment: apptBeforeVisitsWrapper,
  fu_htn_bot_start_requested: fuHtnBotStartRequested,
  fu_dm_bot_start_requested: fuDmBotStartRequested,
  fu_mh_bot_start_requested: fuMhBotStartRequested,
  fu_primary_hmo_bot_start_requested: fuPrimaryHmoBotStartRequested,
  nav_to_prescription: navToPrescription,
  nav_to_medical_note: navToMedicalNote,
  nav_to_referral_result: navToReferralResult,
  nav_to_lab_referral: navToLabReferral,
  nav_to_quest_referral: navToQuestReferral,
  nav_to_single_claim: navToSingleClaim
}

export const customNavWrapper = (
  dispatch,
  navigations,
  notificationId,
  notificationSeen
) => {
  navigationMapper[navigations?.sub_type](dispatch, navigations)
  markNotificationAsSeen(dispatch, notificationId, notificationSeen)
}
